module.exports = __webpack_public_path__ + "img/finland-skin-connective-and-musculoskeletal-diseases-female.62bee12b.png";